export const ERROR_MODULE_INITIALIZATION = 'Error module initialization'
export const ERROR_MODULE_NOT_INITIALIZED = 'Error module isn\'t initialized'
export const ERROR_WEBCAM_INITIALIZATION = 'Error webcam initialization'
